import script from "./WizardBlindCheckStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardBlindCheckStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardBlindCheckStep.vue?vue&type=style&index=0&id=4dbe06b9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dbe06b9"]])

export default __exports__